import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as util from "@app/lib/utility";

import CardStatContent from "../../components/CardStatContent";
import ContentBranchNurseryList from "./ContentBranchNurseryList";

const ContentBranch = forwardRef(({ isRoleBranch, statPeriod, libCategories, branchId, branchName, onSelectNursery, updateMainStat, stat }, ref) => {
    const [childStatDate, setChildStatDate] = useState(false);
    const [statTotalClass, setStatTotalClass] = useState(0);
    const [statTotalContractChild, setStatTotalContractChild] = useState(0);
    const [statTotalChildJoin, setStatTotalChildJoin] = useState(0);
    const [statSelected, setStatSelected] = useState(null);
    const [sortOption, setSortOption] = useState({ colId: "nurseryName", sort: "asc" });

    const getStat = () => {
        if(stat) {
            applyData(stat);
            return;
        }
        axios({
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            url: Constant.API_DOMAIN + `/api/flyeng_stat_2022/home/activity/branch/${branchId}`,
            data: {
                start: statPeriod.startDate,
                end: statPeriod.endDate,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    var stat = result.data.data;
                    if (stat && stat.length > 0) {
                        stat.forEach((n) => {
                            if (!n.nurseryName) {
                                n.nurseryName = "[원정보없음]";
                            }
                        });
                    }
                    updateMainStat(result.data);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const applyData = (data) => {
        var childStatDate = data.childStatDate;
        var stat = data.data;
        var statTotalClass = 0;
        var statTotalContractChild = 0;
        var statTotalChildJoin = 0;
        if (stat && stat.length > 0) {
            stat.forEach((n) => {
                if (n.nurseryName != "[원정보없음]") {
                    statTotalClass += n.countClass ? n.countClass : 0;
                    statTotalContractChild += n.contractChild ? n.contractChild : 0;
                    statTotalChildJoin += n.childJoin ? n.childJoin : 0;
                }
            });
        }
        setChildStatDate(childStatDate);
        setStatTotalClass(statTotalClass);
        setStatTotalContractChild(statTotalContractChild);
        setStatTotalChildJoin(statTotalChildJoin);
    };

    const onListSortChanged = (colId, sort) => {
        setSortOption({ sortOption: { colId, sort } });
    };

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            var statData = stat && stat.data ? stat.data : [];
            if (statData && statData.length > 0) {
                if (sortOption.colId) {
                    statData.sort(function (a, b) {
                        if (sortOption.colId === "nurseryName") {
                            return a[sortOption.colId].localeCompare(b[sortOption.colId]) * (sortOption.sort === "asc" ? 1 : -1);
                        } else {
                            return (a[sortOption.colId] - b[sortOption.colId]) * (sortOption.sort === "asc" ? 1 : -1);
                        }
                    });
                }
                const excelData = {
                    fileName: "플라잉홈_원별통계",
                    sheets: [
                        {
                            name: "원별통계",
                            title: `${isRoleBranch ? "" : branchName + " -"} 원별 통계`,
                            columnTitle: ["원명", "계약 반 수", "계약 원아 수", "가입 원아 수"].concat(libCategories ? libCategories.map((lc) => `${lc.name} 실행 수`) : []),
                            data: statData
                                ? statData.map((s) =>
                                      [s.nurseryName, s.countClass, s.contractChild, s.childJoin].concat(libCategories ? libCategories.map((lc) => s[`playCountSumCat_${lc.id}`] || 0) : 0)
                                  )
                                : [],
                        },
                    ],
                };
                callback(null, excelData);
            }
        },
    }));

    useEffect(() => {
        if (statPeriod && branchId) {
            getStat();
        }
        return () => {};
    }, [statPeriod, branchId]);

    useEffect(() => {
        applyData(stat);
        return () => {};
    }, [stat]);

    return (
        <div className="stat-branch-content">
            <div className="row w-100 mb-0 mt-0 text-right">
                <div className="col">
                    <div className="text-right text-muted text-xs">* 원아 자료 기준일 - {childStatDate}</div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="1" title="계약 원" total={stat && stat.data ? stat.data.length.toLocaleString() : "-"} titleBgClass="bg-tomonote" />
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="2" title="계약 클래스" total={statTotalClass.toLocaleString()} titleBgClass="bg-tomonote" />
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="3" title="계약 원아 수" total={statTotalContractChild.toLocaleString()} titleBgClass="bg-tomobooks" />
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="3" title="가입 원아 수" total={statTotalChildJoin.toLocaleString()} titleBgClass="bg-tomobooks" />
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <ContentBranchNurseryList
                        isRoleBranch={isRoleBranch}
                        libCategories={libCategories}
                        data={stat ? stat.data : false}
                        height="500"
                        onRowClick={onSelectNursery}
                        onListSortChanged={onListSortChanged}
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-12">
                    <div className="text-xs text-primary float-right">
                        ※ 정확한 통계 제공을 위해 현재 날짜의 전일까지의 통계만 제공됩니다.
                        <br />※ 당해 학년도의 3월~2월까지의 통계 데이터만 제공됩니다.
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ContentBranch;
